/* Benedicthe theme · scripts */
(function () {
  'use strict';

  var theme = window.theme || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* Toast -------------------------------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* Drawers ------------------------------------------------------------ */
  var lastFocus = null;
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) {
      var btn = t.closest('[data-menu-open]');
      btn.setAttribute('aria-expanded', 'true');
      openDrawer($('[data-menu-drawer]'));
    } else if (t.closest('[data-menu-close]')) {
      var toggle = $('[data-menu-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      closeDrawer($('[data-menu-drawer]'));
    } else if (t.closest('[data-cart-open]') && $('[data-cart-drawer]')) {
      e.preventDefault();
      openDrawer($('[data-cart-drawer]'));
    } else if (t.closest('[data-cart-close]')) {
      closeDrawer($('[data-cart-drawer]'));
    } else if (t.closest('[data-search-open]')) {
      var bar = $('[data-search-bar]');
      if (bar) {
        e.preventDefault();
        bar.hidden = !bar.hidden;
        if (!bar.hidden) $('input[type="search"]', bar).focus();
      }
    } else if (t.closest('[data-search-close]')) {
      var sb = $('[data-search-bar]');
      if (sb) sb.hidden = true;
    } else if (t.closest('[data-toggle-recover]')) {
      e.preventDefault();
      var rec = $('#RecoverPassword');
      var log = $('#CustomerLogin');
      if (rec && log) { rec.hidden = !rec.hidden; log.hidden = !log.hidden; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      var sb = $('[data-search-bar]');
      if (sb) sb.hidden = true;
    }
  });

  /* Announcement rotation ---------------------------------------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    var ms = parseInt(bar.dataset.interval, 10) || 5000;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, ms);
  });

  /* Announcement height var (announcement + header stay on top) -------- */
  var annEl = $('.section-announcement');
  var setAnn = function () { document.documentElement.style.setProperty('--ann-height', (annEl ? annEl.offsetHeight : 0) + 'px'); };
  setAnn();
  window.addEventListener('resize', setAnn);

  /* Marquee: constant slow speed in px per second ---------------------- */
  $$('.marquee').forEach(function (m) {
    var track = $('.marquee__track', m);
    var group = $('.marquee__group', m);
    if (!track || !group) return;
    var pps = parseFloat(m.dataset.pxPerSecond) || 30;
    var setSpeed = function () { track.style.animationDuration = Math.max(10, group.offsetWidth / pps) + 's'; };
    setSpeed();
    window.addEventListener('resize', setSpeed);
  });

  /* Countdown (real end date, or real shipping cutoff) --------------- */
  function osloParts(d) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, weekday: 'short' });
    var o = {}; f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return o;
  }
  function osloOffsetMs(d) {
    var o = osloParts(d);
    var asUtc = Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
    return asUtc - Math.floor(d.getTime() / 1000) * 1000;
  }
  function osloToDate(y, mo, da, h, mi) {
    var guess = new Date(Date.UTC(y, mo - 1, da, h, mi, 0));
    return new Date(guess.getTime() - osloOffsetMs(guess));
  }
  $$('[data-countdown]').forEach(function (el) {
    var mode = el.dataset.mode;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var hEl = $('[data-cd-h]', el), mEl = $('[data-cd-m]', el), sEl = $('[data-cd-s]', el);
    function target() {
      var now = new Date();
      if (mode === 'deadline') {
        var m = (el.dataset.end || '').match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
        if (!m) return null;
        return osloToDate(+m[1], +m[2], +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59);
      }
      var o = osloParts(now);
      var wd = o.weekday;
      if (el.dataset.weekdays === 'true' && (wd === 'Sat' || wd === 'Sun')) return null;
      var t = osloToDate(+o.year, +o.month, +o.day, parseInt(el.dataset.cutoff, 10) || 14, 0);
      return t > now ? t : null;
    }
    var timeEl = $('.countdown__time', el);
    var noDate = mode === 'deadline' && !(el.dataset.end || '').trim();
    function tick() {
      if (noDate) { el.hidden = false; if (timeEl) timeEl.hidden = true; return; }
      var t = target();
      var diff = t ? t.getTime() - Date.now() : 0;
      if (!t || diff <= 0) { el.hidden = true; return; }
      el.hidden = false;
      var s = Math.floor(diff / 1000);
      var h = Math.floor(s / 3600);
      hEl.textContent = pad(h); mEl.textContent = pad(Math.floor(s % 3600 / 60)); sEl.textContent = pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* Sticky add to cart bar (product page) ------------------------------ */
  var sticky = $('[data-sticky-atc]');
  var mainForm = $('[data-product] .product-form');
  if (sticky && mainForm) {
    var mainBtn = $('[data-add-button]', mainForm);
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      document.body.classList.toggle('has-sticky-atc', !sticky.hidden);
    });
    io.observe(mainBtn || mainForm);
    $('[data-sticky-atc-btn]', sticky).addEventListener('click', function () {
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    });
  }

  /* Header: height var + solid on scroll ------------------------------ */
  var headerEl = $('[data-header]');
  if (headerEl) {
    var setH = function () { document.documentElement.style.setProperty('--header-height', headerEl.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);
    if (headerEl.classList.contains('header--transparent')) {
      var onScroll = function () { headerEl.classList.toggle('is-solid', window.scrollY > 10 || !!$('.drawer.is-open')); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  /* Sort dropdown: close on outside click */
  document.addEventListener('click', function (e) {
    $$('[data-sort-dd][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });

  /* Slideshow ---------------------------------------------------------- */
  $$('[data-slideshow]').forEach(function (show) {
    var slides = $$('[data-slide]', show);
    var dots = $$('[data-slide-to]', show);
    if (slides.length < 2) return;
    var current = 0;
    var timer = null;
    function go(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      var vid = slides[current].querySelector('video');
      if (vid) { try { vid.play(); } catch (e) {} }
    }
    function start() {
      if (show.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(function () { go(current + 1); }, parseInt(show.dataset.interval, 10) || 6000);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.dataset.slideTo, 10)); start(); });
    });
    var touchX = null;
    show.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    show.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); start(); }
      touchX = null;
    });
    show.addEventListener('mouseenter', stop);
    show.addEventListener('mouseleave', start);
    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) { stop(); go(i); }
    });
    start();
  });

  /* Timeline ----------------------------------------------------------- */
  $$('[data-timeline]').forEach(function (tl) {
    var panels = $$('[data-timeline-panel]', tl);
    var tabs = $$('[data-timeline-tab]', tl);
    function show(i) {
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      tabs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.timelineTab, 10)); });
    });
    document.addEventListener('shopify:block:select', function (e) {
      var i = panels.indexOf(e.target);
      if (i > -1) show(i);
    });
  });

  /* Cart --------------------------------------------------------------- */
  function sectionsUrl() {
    return (theme.routes && theme.routes.root ? theme.routes.root : '/') .replace(/\/?$/, '/') + '?sections=cart-drawer';
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function renderDrawer(html) {
    var drawer = $('[data-cart-drawer]');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer]');
    if (!fresh) return;
    var panel = $('.drawer__panel', drawer);
    var freshPanel = $('.drawer__panel', fresh);
    if (panel && freshPanel) panel.innerHTML = freshPanel.innerHTML;
  }

  function refreshCart() {
    return fetch(sectionsUrl(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data['cart-drawer']); })
      .then(function () { return fetch(theme.routes.cart + '.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function changeLine(line, quantity, container) {
    if (container) container.classList.add('is-loading');
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (cart) {
        // Cart page: reload to keep totals and discounts exact.
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        return refreshCart();
      })
      .catch(function (err) {
        toast((err && (err.description || err.message)) || theme.strings.error);
      })
      .finally(function () { if (container) container.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var item = btn.closest('[data-line]');
    if (!item) return;
    e.preventDefault();
    var container = btn.closest('[data-cart-contents]') || btn.closest('[data-cart-page]');
    changeLine(parseInt(item.dataset.line, 10), parseInt(btn.dataset.qtyChange, 10), container);
  });

  /* Add to cart (AJAX) ------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !theme.routes) return;
    var hasDrawer = !!$('[data-cart-drawer]');
    e.preventDefault();

    var submit = form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    if (submit) { submit.setAttribute('aria-busy', 'true'); submit.disabled = true; }

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        if (!hasDrawer) { window.location.href = theme.routes.cart; return; }
        return refreshCart().then(function () { openDrawer($('[data-cart-drawer]')); });
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || theme.strings.error;
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { toast(msg); }
      })
      .finally(function () {
        if (submit) {
          submit.removeAttribute('aria-busy');
          if (!submit.dataset.soldOut) submit.disabled = false;
        }
      });
  });

  /* Quantity stepper (product page) ------------------------------------ */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('.qty__input');
    if (!input) return;
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
  });

  /* Variant picker ----------------------------------------------------- */
  function formatMoney(cents) {
    var format = theme.moneyFormat || '{{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  $$('[data-product]').forEach(function (product) {
    var picker = $('[data-variant-picker]', product);
    var gallery = $('[data-gallery]', product);

    function showMedia(id) {
      if (!gallery || !id) return;
      $$('.product__media-item', gallery).forEach(function (el) {
        el.classList.toggle('is-active', String(el.dataset.mediaId) === String(id));
      });
      $$('[data-thumb]', gallery).forEach(function (el) {
        el.classList.toggle('is-active', String(el.dataset.thumb) === String(id));
      });
    }

    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (thumb) showMedia(thumb.dataset.thumb);
      });
    }

    if (!picker) return;
    var dataEl = $('[data-variants]', picker);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);

    picker.addEventListener('change', function () {
      var selected = $$('fieldset', picker).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      $$('fieldset', picker).forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = selected[i];
      });

      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      var idInput = $('[data-variant-id]', product);
      var addBtn = $('[data-add-button]', product);
      var priceWrap = $('[data-price-wrapper] [data-price]', product);

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.dataset.soldOut = '1'; addBtn.textContent = theme.strings.unavailable; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (variant.available) { delete addBtn.dataset.soldOut; } else { addBtn.dataset.soldOut = '1'; }
        addBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      }
      if (priceWrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--sale', !!onSale);
        priceWrap.innerHTML = '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
          (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '');
        var saveBadge = $('[data-save-badge]', product);
        if (saveBadge) {
          saveBadge.hidden = !onSale;
          if (onSale) saveBadge.textContent = (theme.strings.save || 'Spar __AMOUNT__').replace('__AMOUNT__', formatMoney(variant.compare_at_price - variant.price));
        }
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Collection sort & filter ------------------------------------------- */
  $$('[data-filter-form]').forEach(function (form) {
    var sort = $('[data-sort]', form);
    if (sort) sort.addEventListener('change', function () { form.submit(); });
  });

  /* Product recommendations -------------------------------------------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  /* Account: address delete confirm + country default ----------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-confirm]');
    if (form && !window.confirm(form.dataset.confirm)) e.preventDefault();
  });
  $$('select[data-default]').forEach(function (sel) {
    var val = sel.dataset.default;
    if (val) sel.value = val;
  });
})();

/* v16: dots for the info slide on mobile */
(function () {
  document.querySelectorAll('.multicolumn--plain .multicolumn__list').forEach(function (list) {
    var items = list.querySelectorAll('.multicolumn__item');
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'multicolumn__dots';
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'multicolumn__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', String(i + 1));
      b.addEventListener('click', function () { list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b);
    });
    list.parentNode.insertBefore(dots, list.nextSibling);
    list.addEventListener('scroll', function () {
      var i = Math.round(list.scrollLeft / list.clientWidth);
      dots.querySelectorAll('.multicolumn__dot').forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
  });
})();

/* v16: swipe gallery dots on mobile product pages */
(function () {
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('.product__main-media');
    if (!track) return;
    var items = track.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'product__dots';
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', String(i + 1));
      b.addEventListener('click', function () { track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(b);
    });
    track.parentNode.insertBefore(dots, track.nextSibling);
    var mobile = window.matchMedia('(max-width: 989px)');
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.querySelectorAll('.product__dot').forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
    /* when a variant switches the image, slide to it */
    new MutationObserver(function () {
      if (!mobile.matches) return;
      var active = track.querySelector('.product__media-item.is-active');
      if (active) track.scrollTo({ left: active.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }).observe(track, { subtree: true, attributes: true, attributeFilter: ['class'] });
  });
})();
